const testimonials = [
  {
    name: "Dr. Patricia L.",
    location: "North Scottsdale / Mayo Clinic",
    rating: 5,
    text: "I had a research symposium presentation in Stockholm with 11 days notice and my passport was expired — it had lapsed during the pandemic when I was not traveling internationally. Fast Passport Center reviewed my renewal documents the same day I contacted them, submitted through their courier access, and I had my passport in seven business days. Made my flight from PHX without any issue. Absolutely indispensable for physician travelers.",
    service: "Expedited Renewal",
  },
  {
    name: "Robert K.",
    location: "DC Ranch, Scottsdale",
    rating: 5,
    text: "I collect classic and exotic cars and attend international auctions, including Concours events in France and England. I discovered my passport expired three weeks before a Goodwood event I had been planning for months. Fast Passport Center handled everything remotely — I shipped overnight from my home in DC Ranch and had a fresh passport back in five business days. Genuinely the only service I would trust for a time-sensitive situation like this.",
    service: "Passport Renewal",
  },
  {
    name: "Amelia & James T.",
    location: "Gainey Ranch, Scottsdale",
    rating: 5,
    text: "We booked a last-minute Mediterranean cruise as an anniversary gift to ourselves and immediately realized our adult daughter traveling with us had an expired passport. We found Fast Passport Center online, contacted them Monday morning, shipped the application Monday afternoon, and she had her renewed passport Thursday. We were on the ship the following Tuesday. The whole experience was professional, fast, and incredibly low-stress given the timeline.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ScottsdaleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Scottsdale &amp; Northeast Phoenix Metro Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Mayo Clinic physicians, automotive collectors, and Scottsdale professionals who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}